import { ModelsAddMoreTierProps, TYPES } from "./actions";
import { PropAction } from "../props";

const initial_substate = {
  checkedList: [],
};
const initial_promotion_product_model = {
  models: {},
};
const initial_substate_alt = {
  values: {},
};
const initial_subtotal_alt = {
  subtotal: 0,
};
const initial_items_alt = {
  items: [],
};
export type ModelsState = {
  models: any;
  order_items: any;
  order_total: any;
  customers: any;
  refund_items: any;
  order_history: any;
  orders: any;
  products: any;
  classifications: any;
  inventory: any;
  classificationCharacter: any;
  classificationCategory: any;
  classificationProductType: any;
  classificationProduct: any;
  categoryBasicAttributes: any;
  categoryFeatureCarousel: any;
  categoryPageSetting: any;
  point_history: any;
  pages: any;
  pageElements: any;
  navigation: any;
  promotionGroups: any;
  promotionProducts: any;
  promotionProductsDetailModel: any;
  addPromotionProducts: any;
  productGroups: any;
  qa: any;
  allReviews: any;
  voucherDetail: any;
  promotionDetail: any;
  getAllPromotionProducts: any;
  getAllConditionPromotionProducts: any;
};

const initial_state: ModelsState = {
  models: [],
  order_items: { ...initial_items_alt },
  order_total: { value: 0 },
  customers: { ...initial_substate },
  refund_items: { ...initial_substate_alt, ...initial_subtotal_alt },
  order_history: { ...initial_substate },
  orders: { ...initial_substate, ...initial_items_alt },
  products: { ...initial_substate },
  classifications: {
    ...initial_substate,
    activeTab: {
      tabIndex: 0,
      tabName: "character",
    },
  },
  inventory: { ...initial_substate },
  classificationCharacter: { ...initial_substate },
  classificationCategory: { ...initial_substate },
  classificationProductType: { ...initial_substate },
  classificationProduct: { ...initial_substate },
  categoryBasicAttributes: {},
  categoryPageSetting: {},
  categoryFeatureCarousel: {},
  point_history: { ...initial_substate },
  pages: { ...initial_substate },
  pageElements: { ...initial_substate },
  navigation: { ...initial_substate },
  promotionGroups: { ...initial_substate },
  promotionProducts: { ...initial_substate },
  promotionProductsDetailModel: { ...initial_promotion_product_model },
  addPromotionProducts: { ...initial_substate },
  productGroups: {
    ...initial_substate,
    activeTab: { tabIndex: 0 },
    accessory: { published: 0 },
    gift: { published: 0 },
    discount: { published: 0 },
  },
  qa: { ...initial_substate },
  allReviews: { ...initial_substate },
  voucherDetail: {},
  promotionDetail: {},
  getAllPromotionProducts: {},
  getAllConditionPromotionProducts: {},
};

export default (state: ModelsState = initial_state, actions: PropAction) => {
  switch (actions.type) {
    case TYPES.UPDATE:
      const updateProps: ModelsAddMoreTierProps = actions.props;
      return {
        ...state,
        [updateProps.key]: updateProps.value,
      };
    default:
      return state;
  }
};
